import {
  DayPickerProps as DayPickerPropsType,
  RangeModifier as RangeModifierType,
} from 'react-day-picker';
import { DateRange as DateRangeType } from './types';

export { default as DateInput } from './components/DateInput';
export { default as Calendar } from './components/Calendar';
export { default as CalendarFooter } from './components/CalendarFooter';
export { default as CalendarInfo } from './components/CalendarInfo';

export { default as addMonths } from './helpers/addMonths';
export { default as makeDayTestLocator } from './helpers/makeDayTestLocator';
export { default as isDayInThePast } from './helpers/isDayInThePast';
export { default as isDayExcluded } from './helpers/isDayExcluded';
export { default as isDayAfter } from './helpers/isDayAfter';
export { default as isDayBefore } from './helpers/isDayBefore';
export { default as isDayInMoveInWindow } from './helpers/isDayInMoveInWindow';

export type DateRange = DateRangeType;
export type DayPickerProps = DayPickerPropsType;
export type RangeModifier = RangeModifierType;
